import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Utils } from '../utils/utils';

@Component({
  selector: 'cm-custom-upload-button',
  template: `

    <label for="{{id}}" *ngIf="label" class="cm-upload-button-label">
      {{label}}
    </label>
    <label for="{{id}}" (click)="fileInput.click()" [hidden]="!!file" class="cm-upload-button-box">
      <i class="fas fa-upload"></i>
      <span>{{uploadBtnText ? uploadBtnText : 'Upload file'}}</span>
    </label>
    <span [hidden]="!file" class="cm-uploaded-box">
      <span class="cm-upload-file-name">{{file?.name}}</span>
      <!--<span class="cm-remove-upload">-->
      <!--<i class="far fa-trash-alt" (click)="file = null"></i>-->
      <!--</span>-->
      <span class="cm-re-upload" (click)="fileInput.click()">
        <i class="fas fa-upload"></i>
      </span>
    </span>
    <span style="visibility: hidden; position: absolute; overflow: hidden; width: 0px; height:0px;border:none;margin:0; padding:0">
      <input type="file"
             #fileInput
             [id]="id+'1'"
             (change)="handleFileInput($event.target.files)">
    </span>

  `,
  host: {'class': 'cm-custom-upload-button'}
})
export class CustomUploadButtonComponent {

  @Output()
  public fileSelected: EventEmitter<File> = new EventEmitter();

  @Output()
  public fileCanceled: EventEmitter<string> = new EventEmitter();

  @Input()
  public label: string;

  @Input()
  public uploadBtnText: string;

  file: File;

  public id = Utils.generateGuid();

  handleFileInput(file: FileList): void {
    if (file.length) {
      this.file = file.item(0);
      this.fileSelected.emit(file.item(0));
    } else {
      const fileName = this.file.name;
      this.file = null;
      this.fileCanceled.emit(fileName);
    }
  }

  getFile() {
    return this.file;
  }

  reset() {
    this.file = null;
  }

}
